import { useState, useCallback } from 'react';

// Create a custom useForceUpdate hook with useState
export const useForceUpdate = () => {
  const func = useState()[1];
  return useCallback(() => {
    func({});
  }, [func]);
};
